<template>
  <Dialog
    :visible="visible"
    dismissableMask
    modal
    header="Contact Us"
    @update:visible="$emit('update:visible', $event)"
  >
    <div>
      Have any questions or comments? Contact our support.
    </div>

    <div class="mt-2">
      <a
        class="text-primary"
        :href="mailTo"
      >
        Email
        {{ SUPPORT_EMAIL }}
        <i class="text-sm pi pi-external-link" />
      </a>
    </div>

    <template #footer>
      <div class="flex justify-content-end">
        <Button
          text
          plain
          label="Close"
          @click="$emit('update:visible', false)"
        />
      </div>
    </template>
  </Dialog>
</template>

<script>
import { mapStores } from 'pinia';
import { useMyUserStore } from '@/stores';
import { SUPPORT_EMAIL } from '@/constants';
import { generateBodyText } from '@/utils/support';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapStores(useMyUserStore),
    mailTo() {
      const subject = 'Ekoz.ai App Contact Form';

      const body = generateBodyText({
        userId: this.myUserStore.userId,
        url: window.location.href,
      });

      return `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
    },
  },
  data() {
    return {
      SUPPORT_EMAIL,
    };
  },
};
</script>
